import React from 'react';
import Logo from '../components/Logo/Logo';
import ScrollIndicator from '../components/ScrollIndicator/ScrollIndicator';
import ScrollProgressBar from '../components/ScrollProgressBar/ScrollProgressBar';
import ScrollHeader from '../components/ScrollHeader/ScrollHeader';
import AboutSection from '../components/AboutSection/AboutSection';
import ResumeSection from '../components/ResumeSection/ResumeSection';
import ContactSection from '../components/ContactSection/ContactSection';
import useScrollProgress from '../hooks/useScrollProgress';
import './Home.css';

const Home = () => {
  const { scrollContentRef, progressBarRef } = useScrollProgress();

  return (
    <>
      <div className="static-hero">
        <Logo />
        <ScrollIndicator />
      </div>
      <div className="scroll-content" ref={scrollContentRef}>
        <ScrollProgressBar ref={progressBarRef} />
        <ScrollHeader />
        <AboutSection />
        <ResumeSection />
        <ContactSection />
      </div>
    </>
  );
};

export default Home;